module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-w flex-column timeline-container"
  }, [_vm._l((_vm.points), function(p) {
    return _c('div', {
      staticClass: "point-container"
    }, [_c('div', {
      staticClass: "full-w flex point-header space-between"
    }, [_c('div', {
      staticClass: "flex point-date"
    }, [_c('span', {
      staticClass: "point-day flex justify-center",
      class: {
        'weekend': _vm.isWeekend(p.date)
      }
    }, [_vm._v(_vm._s(p.day))]), _vm._v(" "), _c('span', {
      staticClass: "point-month"
    }, [_vm._v(_vm._s(p.month))])]), _vm._v(" "), _c('a', {
      staticClass: "point-add",
      on: {
        "click": function($event) {
          return _vm.create(p.date)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('button.add')))])]), _vm._v(" "), _c('div', {
      staticClass: "flex-column start point-content"
    }, [_vm._l((_vm.getDayOrders(p.date)), function(o) {
      return _c('v-appointment-card', {
        staticClass: "full-w",
        attrs: {
          "appointment": o,
          "edit": _vm.onEdit(p.date)
        }
      })
    }), _vm._v(" "), (_vm.getDayOrders(p.date).length === 0) ? _c('span', {
      staticStyle: {
        "padding": "1rem"
      }
    }, [_vm._v(_vm._s(_vm.$t('static.appointments.index.nothingScheduled')))]) : _vm._e()], 2)])
  }), _vm._v(" "), _c('div', {
    staticClass: "trace"
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-965463aa","hasScoped":false}!./src/app/components/timeline/timeline.html
// module id = 3092
// module chunks = 1